import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-store';
import { getAccessToken } from '../lib/api';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import { Spinner } from './ui/spinner';

export function ProtectedLayout() {
  const user = useAuth((s) => s.user);
  const hydrate = useAuth((s) => s.hydrate);
  const accessToken = getAccessToken();
  const [verificando, setVerificando] = useState(!!accessToken && !user);

  useEffect(() => {
    let ativo = true;
    if (accessToken && !user) {
      hydrate().finally(() => { if (ativo) setVerificando(false); });
    } else {
      setVerificando(false);
    }
    return () => { ativo = false; };
  }, []);

  // Sem token: direto pro login
  if (!accessToken) return <Navigate to="/login" replace />;

  // Tem token mas ainda buscando o usuário: aguarda
  if (verificando) {
    return <div className="flex h-screen items-center justify-center bg-background"><Spinner /></div>;
  }

  // Terminou de verificar e não conseguiu autenticar
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto px-6 py-6 lg:px-8 lg:py-8">
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
